function initFields(formEl, fieldSelector, notEmptyClass) {
    const inputEl = `${fieldSelector}__input`;
    const fieldInputs = formEl.querySelectorAll(inputEl);
if (fieldInputs) {
	fieldInputs.forEach(item => {
		item.addEventListener('input', function() {
			let field = item.closest(fieldSelector);
			if (item.value) {
				field.classList.add(notEmptyClass);
			} else {
				field.classList.remove(notEmptyClass);
			}
		});
	})	
}

}

export default initFields;

